/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.25",
    versionName: "0.2.0-nightly.2026.2.25",
    versionChannel: "nightly",
    buildDate: "2026-02-25T00:13:44.136Z",
    commitHash: "f4c86ec09550a1c8df45e0f6f22d56edb8cca4f1",
};
